<template>
  <b-card no-body class="recap">
    <b-card-header class="recap__header">
      <div class="recap__header-element recap__header-element--first">
        <div class="recap__header-item">
          <vb-icon class="recap__header-icon mr-1" :name="'calendar'" :color="'053B95'" :size="16" />
          <span v-html="parse_date(checkin).day_number + ' ' + parse_date(checkin).month_string + ' ' + parse_date(checkin).year" />
          <span class="ml-1" v-html="'- ' + parse_date(checkout).day_number + ' ' + parse_date(checkout).month_string + ' ' + parse_date(checkout).year" />
        </div>
        <div class="recap__header-item">
          <vb-icon class="recap__header-icon mr-1" :name="'occupants'" :color="'053B95'" :size="16" />
          <span class="reservation__info-text semibold" v-html=
            "solution.checkout_payload.occupancy.reduce((total, item) => total + item.adults, 0) + ' adulti'"
          />
          <span class="ml-1" v-if="solution.checkout_payload.occupancy.reduce((total, item) => total + item.children.length, 0) > 0" v-html=
            "' e ' +solution.checkout_payload.occupancy.reduce((total, item) => total + item.children.length, 0) + (solution.checkout_payload.occupancy.reduce((total, item) => total + item.children.length, 0) > 1 ? ' bambini' : ' bambino')"
          />
        </div>
      </div>
      <div class="recap__header-element recap__header-element--second">
        <div class="recap__header-item recap__header-item--hotel">
          <vb-icon class="recap__header-icon mr-1" :name="'pin'" :color="'053B95'" :size="12" />
          <span class="semibold" v-html="solution.hotel_name" />
          <span v-html="solution.hotel_address" />
        </div>
      </div>
    </b-card-header>
    <b-card-body>
      <div class="recap__room" v-for="(room, room_index) in solution.rooms" :key="_uid+'recap_room'+room_index">
        <div class="recap__room-head">
          <span class="recap__room-title" v-html="room.name" />
        </div>
        <div class="recap__blocks">
          <div class="recap__block" v-for="(block, block_index) in room.blocks" :key="_uid+'recap_room_block'+block_index">
            <span class="recap__block-num" v-html="block.incremental_price_selected.quantity + 'x'" />
            <occupancy-block :block="block" :occupancy="occupancy" />
            <mealplan-refundable-block :block="block" />
          </div>
        </div>
      </div>
      <b-card-text class="recap__price">
        <span v-html="'include gestione e assistenza'" />
        <span v-html="'€ ' + solution.checkout_payload.live_price" />
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import OccupancyBlock from '@booking/components/blocks/occupancy-block.vue'
import MealplanRefundableBlock from '@booking/components/blocks/mealplan-refundable-block.vue'
import { parse_date } from '@utilities/commons'

export default {
  name: 'card-recap',

  components: {
    'occupancy-block': OccupancyBlock,
    'mealplan-refundable-block': MealplanRefundableBlock,
  },

  props: {
    solution: Object
  },

  data() {
    return {
      checkin: this.$store.state.livebk.checkin,
      checkout: this.$store.state.livebk.checkout,
      occupancy: this.$store.state.occupancy,
    }
  },

  computed: {
  },

  created() {
    this.parse_date = parse_date
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .recap {
    border-radius: 10px;
    border: none;

    &__header {
      $this_recap_header: &;
      background-color: #fafcff;
      border-bottom: 1px solid $gray-300;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:first-child {
        border-radius: 10px 10px 0 0;
      }

      &-element {

        &--first {
          display: flex;
          align-items: center;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        margin-left: 15px;

        &:first-child {
          margin-left: 0;
        }

        @at-root #{$this_recap_header}-element--first & {
          font-weight: $vb-font-weight-semibold;
        }

        &--hotel {
          font-size: $font-size-md;

          span {
            &:last-child {
              margin-left: 10px;
            }
          }
        }
      }
    }

    &__room {
      border-top: 1px solid $gray-300;
      margin-top: 20px;
      padding-top: 20px;

      &:first-child {
        padding-top: 0;
        margin-top: 0;
        border-top: 0;
      }

      &-head {
        display: flex;
        align-items: center;
        font-weight: $vb-font-weight-semibold;
      }

      &-num {
        margin-right: 10px;
      }

      /*&-bed {
        display: flex;
        align-items: center;
        margin-left: 10px;

        &_name {
          color: $secondary;
        }
      }*/
    }

    &__blocks {
      margin-left: 10px;
      margin-top: 10px;
    }

    &__block {
      display: flex;
      align-items: center;
      border-top: 1px solid $gray-200;
      margin-top: 10px;
      padding-top: 10px;

      &:first-child {
        margin-top: 0;
        padding-top: 0;
        border-top: 0;
      }

      &-num {
        margin-right: 5px;
        font-weight: $vb-font-weight-semibold;
        color: $primary;
      }
    }

    &__price {
      border-top: 1px solid $gray-200;
      padding-top: 10px;
      margin-top: 10px;

      span {
        &:first-child {
          color: $gray-500;
          font-size: $font-size-md;
          margin-right: 10px;
        }
        &:last-child {
          color: $primary;
          font-size: $font-size-lg;
          font-weight: $vb-font-weight-semibold;
        }
      }
    }
  }

  ::v-deep {

    .occupancy-block {
      margin-right: 20px;
    }

    .mealplan-refundable {
      display: flex;
      align-items: center;

      &__info {
        margin-bottom: 0;
        margin-left: 10px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

</style>